import React from 'react';
import { Container, Card } from 'react-bootstrap';
import PageTitle from '@/common/PageTitle/PageTitle';
import styles from './roles.module.scss';

const Roles: React.FC = () => {
  return (
    <Container fluid>
      <Card className={styles.card}>
        <Card.Body>
          <Card.Title className={styles.cardTitle}>
            <PageTitle title="Employee Roles" />
          </Card.Title>
          {/* Add your roles page content here */}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Roles; 